module.exports = __webpack_public_path__ + "static/media/background.a568fbd8.svg";